import request from '@/utils/request'

// v80b1010List
export function v80b1010List(param) {
    let data = param
    return request({
      url: `/v80/v80b1010/v80b1010List`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
    })
  }